<template>
    <div class="Details">
    <section class="modal-card box" style="min-width: 60em; width: auto" >
        <h2 class="title is-5">
        Performance report
        </h2>
        <b class="subtitle">Model {{model.id}}</b>
        <div class="modal-card-body columns is-multiline is-full" v-if="model.plots">
            <div class="column is-6">
            <p v-if="!overall_report">
                <b-skeleton height="200px"></b-skeleton>
            </p>
            <div class="block box" v-if="overall_report">
              <h2 class="title is-5">Overall metrics</h2>
                <apexchart type="heatmap" 
                height="100"
                :options="metricsOptions" 
                :series="overall_report"></apexchart>
                <!-- <p>
                  <small>
                    <b>Decision confidence threshold:</b> 0.5 (Fine-tuned)<br>
                    </small>
                </p> -->
                <p>
                  <small>
                    
                        <b>Precision and Recall:</b>
                    
                    </small>
                </p>
                <p>
                  <small>
                    
                        {{precision_explained()}}
                    
                    </small>
                </p>
                <p>
                  <small>
                    
                    {{ recall_explained()}}
                    
                  </small>
                </p>
                <b-field  
                message="Metrics are calculated through the cross-validation method"
                ></b-field>
                <!-- <p>
                  <small>
                    <b>Training accuracy:</b><br>
                    {{ model.model_metrics["training"]["accuracy"].toFixed(2)}}
                  </small>
                </p>
                <p>
                  <small>
                    <b>Training time:</b><br>
                    {{ model.model_metrics.training.time.toFixed(2)}} seconds
                  </small>
                </p> -->

            </div>
            </div>
            <div class="column is-half">
            <p v-if="!data_report">
                <b-skeleton height="300px"></b-skeleton>
            </p>
            <div class="block box" v-if="data_report">
            <h2 class="title is-5">Metrics per label</h2>
            
            <apexchart type="heatmap" 
                :height="Math.min(data_report.length * 35, 1500)"
              :options="reportOptions" 
              :series="data_report"></apexchart>

            </div>

            </div>
            <!-- <div class="column is-half">
            <div class="block box" v-if="confusion_matrix">

            <h2 class="title is-5">Confusion matrix</h2>

            <apexchart type="heatmap" 
              :options="cfOptions" 
              :series="confusion_matrix"></apexchart>
            </div>
          </div> -->

                

        </div>
        <div class="modal-card-body columns is-multiline is-full" v-else>
            <p class="subtitle is-5">
                <i class="fa fa-exclamation-triangle"></i> No report generated</p>
            
        </div>
        
    </section>

    </div>
</template>
<script>
import { Plotly } from 'vue-plotly'

   export default {
     props: ["modelId"],
     name: "Training",
     data: function() {
    return {
      activeTab: 'pictures',
      selectedVersion: 'v1',
                showMusic: true,
                showBooks: false,
                multiline: true,
      data_report: false,
      overhall_report: false,
      confusion_matrix: false,
      data1:[{
        z: [[1, 20, 30], [20, 1, 60], [30, 60, 1]],
        type:"heatmap"
    }],
    layout:{
      title: "a"
    },
    plotBarOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
          },
        },
      data: [
                    { 'first_name': 'Label 1', 'last_name': '0.99', 'support': '100', },
                    { 'first_name': 'Label 2', 'last_name': '0.98', 'support': '98',},
                    { 'first_name': 'Macro', 'last_name': '0.98', 'support': '198',},
                    { 'first_name': 'Weighted', 'support': '198',},
                ],
      cfOptions: {
          chart: {
            height: 350,
            type: 'heatmap',
          },
          dataLabels: {
            enabled: true
          },
          colors: ["#0074cc"],
        },
        metricsOptions: {
          chart: {
            height: 10,
            type: 'heatmap',
          },
          dataLabels: {
            enabled: true
          },
          // colors: ['#f3cec9', '#e7a4b6', '#cd7eaf', '#a262a9', '#6f4d96', '#3d3b72', '#182844'],
          colors: [function({ value, seriesIndex, w }) {
    const baseColor = [52, 130, 246]; // RGB values for #3482F6
    const darkenFactor = value; // Use 1 for more darker and 0 for more lighter

    const darkerTone = baseColor.map(component => Math.round(component * darkenFactor));
    
    return `rgb(${darkerTone[0]}, ${darkerTone[1]}, ${darkerTone[2]})`;
}],

          title: {
          },
        },
        reportOptions: {
    chart: {
        height: 350,
        type: 'heatmap',
        
    },
    colors: [function({ value, seriesIndex, w }) {
    const baseColor = [52, 130, 246]; // RGB values for #3482F6
    const darkenFactor = value; // Use 1 for more darker and 0 for more lighter

    const darkerTone = baseColor.map(component => Math.round(component * darkenFactor));
    
    return `rgb(${darkerTone[0]}, ${darkerTone[1]}, ${darkerTone[2]})`;
}],

    dataLabels: {
        enabled: true,
    },
    animated: true
}
    }},
    components: {
      Plotly
    },
     computed: {
      
      model() {
         return this.$store.state.currentModel;
       },
      datasets() {
         let datasets = [...this.$store.state.datasets, ...this.$store.state.publicDatasets]
         var filteredDatasets = this.searchIds(datasets, this.model.datasets)
         return filteredDatasets
       },
       items() {
         return this.$store.state.currentModelItems;
       }
     },
     mounted() {
        this.$store.dispatch("currentModel", this.modelId);
        setTimeout(() => { this.show() }, 1000)
      },
     created() {
       this.$store.dispatch("currentModel", this.modelId);
       

     },
      methods: {
        precision_explained(){
            let value = this.model.model_metrics["precision"] > 0.75 ? "High precision" : "Low precision"
            let explain = this.model.model_metrics["precision"] > 0.75 ? "means fewer false positives" : "means more false positives"
            return value + " " + explain
        },
        recall_explained(){
            let value = this.model.model_metrics["recall"] > 0.75 ? "High recall" : "Low recall"
            let explain = this.model.model_metrics["recall"] > 0.75 ? "means fewer false negatives" : "means more false negatives"
            return value + " " + explain
        },
        training_accuracy_explained(){
            let value = this.model.model_metrics["training"]["accuracy"] > 0.65 ? "High accuracy" : "Low accuracy"
            let explain = this.model.model_metrics["training"]["accuracy"] > 0.65 ? "can means overfitting" : "can means underfitting"
            return value + " " + explain
        },
        show(){
       this.$store.dispatch("retrieveAllDatasets");
       this.training = true
       this.options = {}
       if (this.model.is_training && this.model.training_status === 100){
         this.updateTrainingStatus()
       }

       this.versions = [
          {id: 'v1', name: 'v1 ' + this.model.name + ' created at '+ this.model.createdAt.toDate()}
        ]
       
       this.confusion_matrix = [] // this.confusion_matrix_report()
       this.data_report = this.data_classification_report(this.model.plots.classification_report)
       this.overall_report = new Array(this.model.plots.overall_report)
        },
        searchIds(toSearch, Ids) {
            Ids = new Set(Ids)
            return toSearch.filter(({id}) => Ids.has(id))
        },
        sort_array(a,b) {
          return a.x == 'f1-score' ? -1 : a.x == 'accuracy' ? 0 : a.x == 'precision' ? 1 : 1;
        },
        data_classification_report(classification_report){
          let proc_data = new Array();
          for(let i=0; i < classification_report.length; i++){
            if( classification_report[i] == undefined || classification_report[i] == null) continue
            proc_data.push(
              classification_report[i]
            )
          }
          return proc_data
        },
        confusion_matrix_report(){
            if (this.model.plots.confusion_matrix == undefined) return []

          let cf = JSON.parse(this.model.plots.confusion_matrix)
          
          let array = cf.matrix
          // console.log(array)
          let data = new Array();
          for(var i=0; i < array.length; i++){
          //for(var i=array.length; i > 0; i--){
            
            // if (array[i].recall === undefined ) continue
            let values = new Array()
            let array_length = array[i].length
            //for(var j=array_length; j > 0; j--){
            
            for(var j=0; j < array[i].length; j++){
              values.push({x: "(Predicted) " +cf.x[j],   y: array[j][i]})
            }
            
            data.push({
                  name: "(True) "+cf.y[i],
                  data: values
            })
          }

          return data
        },
       startTraining(){
        const model = {
           is_training: true,
           training_status: null
         }

         this.$store.dispatch("updateModel", {
          modelId: this.model.id,
          update: model
        });
       },
       updateTrainingStatus(){
         const model = {
           is_training: false
         }

         this.$store.dispatch("updateModel", {
          modelId: this.model.id,
          update: model
        });
       },
       requestRetraining(){

         this.$store.dispatch("modelRetraining", this.model.id);
       }
     }
   };
</script>


<style lang="scss" scoped>
  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 300px));
    gap: 16px;
  
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  </style>